import {
  HeaderProfile,
  Section,
  SideLayoutWrapper,
  SkeletonBox,
  CardItem,
  Container,
} from '@presentation/components';
import type { FC } from 'react';
import type { PageSkeletonProps } from './types';
import * as RootStyled from '../../styled';
import * as Styled from './styled';

export const PageSkeleton: FC<PageSkeletonProps> = (props) => {
  const { backLink } = props;

  return (
    <>
      <HeaderProfile
        title={<SkeletonBox style={{ width: '20%', height: '30px' }} />}
        backLink={backLink}
      />
      <Container>
        <RootStyled.TopWrapper>
          <RootStyled.TopFlexWrapper>
            <RootStyled.TopSlideshowWrapper>
              <SkeletonBox style={{ width: '100%', height: '400px' }} />
            </RootStyled.TopSlideshowWrapper>
            <RootStyled.TopDetailsWrapper>
              <SkeletonBox style={{ width: '100%', height: '180px', marginTop: '10px' }} />

              <RootStyled.TopButtonsContainer>
                <SkeletonBox style={{ width: '100%', height: '180px' }} />
              </RootStyled.TopButtonsContainer>
            </RootStyled.TopDetailsWrapper>
          </RootStyled.TopFlexWrapper>
        </RootStyled.TopWrapper>

        <Section>
          <RootStyled.ParentContainer>
            {Array(2)
              .fill(undefined)
              .map((_, index) => (
                <CardItem
                  key={index}
                  loading
                  content={{
                    title: (
                      <SkeletonBox
                        style={{ width: '100%', height: 21.5, display: 'block', marginBottom: 10 }}
                      />
                    ),
                    text: (
                      <SkeletonBox
                        style={{ width: '100%', height: 21.5, display: 'block', marginBottom: 10 }}
                      />
                    ),
                  }}
                />
              ))}
          </RootStyled.ParentContainer>
        </Section>

        <Section>
          <RootStyled.DescriptionContainer>
            <SkeletonBox style={{ width: '90%', display: 'block', marginBottom: 10 }} />
            <SkeletonBox style={{ width: '90%', display: 'block', marginBottom: 10 }} />
          </RootStyled.DescriptionContainer>
        </Section>
      </Container>

      <div style={{ marginTop: 50 }}>
        <Styled.PageContainer>
          <SideLayoutWrapper>
            <CardItem
              loading
              content={{
                title: (
                  <SkeletonBox
                    style={{ width: '90%', height: 21.5, display: 'block', marginBottom: 10 }}
                  />
                ),
                subtitle: (
                  <SkeletonBox
                    style={{ width: '90%', height: 21.5, display: 'block', marginBottom: 10 }}
                  />
                ),
                text: (
                  <SkeletonBox
                    style={{ width: '90%', height: 21.5, display: 'block', marginBottom: 10 }}
                  />
                ),
              }}
            />
          </SideLayoutWrapper>
        </Styled.PageContainer>
      </div>

      <Styled.PageContainer>
        <Section>
          <RootStyled.ParentContainer>
            {Array(4)
              .fill(undefined)
              .map((_, index) => (
                <CardItem
                  key={index}
                  loading
                  content={{
                    title: (
                      <SkeletonBox
                        style={{ width: '90%', height: 21.5, display: 'block', marginBottom: 10 }}
                      />
                    ),
                    text: (
                      <SkeletonBox
                        style={{ width: '90%', height: 21.5, display: 'block', marginBottom: 10 }}
                      />
                    ),
                  }}
                />
              ))}
          </RootStyled.ParentContainer>
        </Section>
      </Styled.PageContainer>
    </>
  );
};
